import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { FaCheckCircle, FaChessKnight, FaGem, FaExclamationTriangle, FaAward, FaHashtag, FaCheckDouble, FaCalendarAlt } from "react-icons/fa";
import { formatSumma } from "./utils/format";
import { decodeCertId } from "./utils/crypto";

import CONFIG from "./config";
import "./Verify.css";
import { getRanks, defaultRanks } from "./services/rankService";

function VerifyId() {
    const [titles, setTitles] = useState(defaultRanks);

    useEffect(() => {
        getRanks().then(setTitles);
    }, []);
    const { id } = useParams(); // Expecting "ALhash" 
    const hash = id.replace(/^AL-?/, ""); // Strip AL prefix
    const cleanId = decodeCertId(hash);

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!cleanId) {
            setError("Noto'g'ri sertifikat formati");
            setLoading(false);
            return;
        }
        const fetchData = async () => {
            try {
                const res = await fetch(`${CONFIG.API_BASE_URL}/get_certificate_by_id.php?id=${cleanId}`).then(r => r.json());
                if (res.status === 'success') {
                    setData(res);
                } else {
                    setError(res.message);
                }
            } catch (e) {
                setError("Tarmoq xatoligi");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [cleanId]);

    if (loading) {
        return (
            <div className="verify-container">
                <div className="verify-card loading-card">
                    <div className="verify-loader-spinner"></div>
                    <h1>Sertifikat Tekshirilmoqda</h1>
                    <p>Ma'lumotlar yuklanmoqda...</p>
                </div>
            </div>
        );
    }

    if (error) return (
        <div className="verify-container">
            <div className="verify-card error">
                <div className="verify-icon" style={{ color: '#e74c3c' }}><FaExclamationTriangle /></div>
                <h1>Sertifikat Topilmadi</h1>
                <p>Kiritilgan ID bo'yicha ma'lumot topilmadi: <b>AL-{cleanId}</b></p>
                <p className="verify-error-detail">{error}</p>
                <Link to="/" className="verify-home-btn">Suvoriy.com</Link>
            </div>
        </div>
    );

    // Calculate Title
    const starsCount = parseInt(data.stars);
    const titleIndex = Math.min(starsCount, titles.length - 1);
    const title = titles[titleIndex >= 0 ? titleIndex : 0];

    return (
        <div className="verify-container">
            <div className="verify-card">
                <div className="verify-icon">
                    <FaCheckCircle />
                </div>
                <h1>TASDIQLANDI</h1>

                <div className="verify-name-large">
                    {data.fio}
                </div>

                <div className="verify-details">
                    <div className="verify-row">
                        <span className="verify-label">ID Raqami:</span>
                        <span className="verify-value">
                            <FaHashtag className="verify-row-icon" /> <span className="id-value">AL{String(data.id).padStart(6, '0')}</span>
                        </span>
                    </div>
                    <div className="verify-row compact">
                        <span className="verify-label">Bo'lim:</span>
                        <span className="verify-value rank">
                            <FaAward className="verify-row-icon" /> Algoritm
                        </span>
                    </div>
                    <div className="verify-row">
                        <span className="verify-label">Daraja:</span>
                        <span className="verify-value rank">
                            <FaChessKnight className="verify-row-icon" /> {title}
                        </span>
                    </div>
                    <div className="verify-row">
                        <span className="verify-label">Masala soni:</span>
                        <span className="verify-value">
                            <FaCheckDouble className="verify-row-icon" /> {data.total_solved}
                        </span>
                    </div>
                    <div className="verify-row">
                        <span className="verify-label">Tanga:</span>
                        <span className="verify-value coins">
                            <FaGem className="verify-row-icon" /> {formatSumma(data.coins)}
                        </span>
                    </div>
                    <div className="verify-row">
                        <span className="verify-label">Sana:</span>
                        <span className="verify-value">
                            <FaCalendarAlt className="verify-row-icon" /> {data.date}
                        </span>
                    </div>
                    <div className="verify-row">
                        <span className="verify-label">Status:</span>
                        <span className="verify-value status">Faol</span>
                    </div>
                </div>

                <p className="verify-footer">
                    Ushbu sertifikat <b>Suvoriy.com</b> platformasida haqiqiy deb topildi.
                </p>

                <Link to="/" className="verify-home-btn">
                    Suvoriy.com ga o'tish
                </Link>
            </div>
        </div>
    );
}

export default VerifyId;
